// PURPOSE: Gallery view of all images from trade notes

import React, { useState } from 'react';
import { Carousel, Empty, Image, Modal } from 'antd';
import PropTypes from 'prop-types';

import dayjs from '@tt/dates/dayjs';

import './styles.scss';

export default function ImagesTab({ images }) {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewIndex, setPreviewIndex] = useState(0);

    const handlePreview = (index) => {
        setPreviewIndex(index);
        setPreviewVisible(true);
    };

    if (!images || images.length === 0) {
        return (
            <div className="images-tab-empty">
                <Empty
                    description="No images attached to this trade"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            </div>
        );
    }

    return (
        <div className="images-tab">
            <div className="images-grid">
                {images.map((image, index) => (
                    <div
                        key={image._id || index}
                        className="image-card"
                        onClick={() => handlePreview(index)}
                    >
                        <Image
                            src={image.path}
                            alt={`Trade image ${index + 1}`}
                            preview={false}
                            className="image-thumbnail"
                        />
                        {image.noteDate && (
                            <div className="image-date">
                                {dayjs(image.noteDate).format('MMM D, YYYY')}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <Modal
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
                width="90%"
                className="images-preview-modal"
                centered
            >
                <Carousel initialSlide={previewIndex} dots arrows infinite>
                    {images.map((image, index) => (
                        <div key={image._id || index} className="carousel-slide">
                            <Image
                                src={image.path}
                                alt={`Trade image ${index + 1}`}
                                preview={false}
                            />
                        </div>
                    ))}
                </Carousel>
            </Modal>
        </div>
    );
}

ImagesTab.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string,
            path: PropTypes.string.isRequired,
            noteDate: PropTypes.string
        })
    )
};

ImagesTab.defaultProps = {
    images: []
};
